import { Person, PersonOff, AcUnit,LocalFireDepartment, SmartToy } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import React, { useState, useEffect } from "react";

const WIDTH = 80
const START_HOUR = 6
const LEFT_START = 200;

const HourlyViewScheduleEvent = (props) => {
    let [startHour, startMinutes] = props.event.start_time.split(':')
    let [endHour, endMinutes] = props.event.end_time.split(':')

    //The height of the element is the number of hours * height magic number
    //TODO: Pass in height magic number
    let width = parseInt(endHour) - parseInt(startHour)
    if (parseInt(startMinutes) > 0) {
        let fraction = parseInt(startMinutes) / 60;
        width -= fraction
    }

    if (parseInt(endMinutes) > 0) {
        let fraction = parseInt(endMinutes) / 60;
        width += fraction
    }
    width *= WIDTH

    //The top of the element is the number of hours after the first hour shown * magic height number
    let left = parseInt(startHour) - START_HOUR
    left *= WIDTH
    left += LEFT_START 

    if (parseInt(startMinutes) > 0) {
        let fraction = parseInt(startMinutes) / 60;
        left += (fraction * WIDTH)
    }

    let scheduleBlockClass = "schedule_event " + ((props.event.type == "Event") ? "event" : "repeating");

    let hasRobot = props.event.values.find(v => v.value_label === "robot_mode")

    return (
        <div key={props.event.id} className={scheduleBlockClass} style={{left: left, width: width}} onClick={() => props.openEvent(props.event)}>
            <div className="schedule-event-title">{ props.event.name } </div>
            {
                props.event.values && props.event.values.length ?
                <div key={props.event.values.length} className="schedule-event-value-container">
                    {
                        width > 100 ? props.event.values.map(v => {
                            let key = v.value_label + "_" + props.event.id
                            //TODO Make strings constants
                            if (v.value_label === "heating_setpoint" && !hasRobot) {
                                return <Tooltip key={key} title="Low Temperature">
                                    <div className="event-value">
                                        <LocalFireDepartment style={{transform: "scale(0.8)"}}/>
                                        {v.value} &#176;
                                    </div>
                                </Tooltip>
                            } else if (v.value_label === "cooling_setpoint" && !hasRobot) {
                                return <Tooltip key={key} title="High Temperature">
                                    <div className="event-value">
                                        <AcUnit style={{transform: "scale(0.8)"}}/>
                                        {v.value} &#176;
                                    </div>
                                </Tooltip>
                            } else if (v.value_label === "robot_mode") {
                                return <Tooltip key={key} title="Automation Mode">
                                    <div className="event-value">
                                        <SmartToy style={{transform: "scale(0.8)"}}/>
                                        {v.value} 
                                    </div>
                                </Tooltip>
                            } 
                        })
                    : null}
                </div>
                : null
            }

            {
                props.event.attributes && props.event.attributes.length ?
                <div className="schedule-event-attribute-container">
                    {
                        width > 100 ? props.event.attributes.map(a => {
                            //TODO Make strings constants
                            if (a === "Occupied") {
                                return <Tooltip title="Occupied">
                                    <Person />
                                </Tooltip>
                            } else if (a === "Unoccupied") {
                                return <Tooltip title="Unoccupied">
                                    <PersonOff />
                                </Tooltip>
                            } else {
                               return a
                            }
                        })
                    : null }
                </div>
                : null
            }
        </div>
    )
}

export default HourlyViewScheduleEvent;